var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.6812C11.7877 15.6812 12.4262 15.0427 12.4262 14.255C12.4262 13.4673 11.7877 12.8287 11 12.8287C10.2123 12.8287 9.57373 13.4673 9.57373 14.255C9.57373 15.0427 10.2123 15.6812 11 15.6812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0687 8.76H6.93125C6.86125 8.76 6.8 8.76 6.73 8.76V7.745C6.73 5.18125 7.45625 3.475 11 3.475C14.7887 3.475 15.27 5.32125 15.27 6.93125C15.27 7.2725 15.5412 7.54375 15.8825 7.54375C16.2237 7.54375 16.495 7.2725 16.495 6.93125C16.495 3.825 14.6487 2.25 11 2.25C6.07375 2.25 5.505 5.3825 5.505 7.745V8.83875C3.055 9.145 2.25 10.3875 2.25 13.4412V15.0687C2.25 18.6562 3.34375 19.75 6.93125 19.75H15.0687C18.6562 19.75 19.75 18.6562 19.75 15.0687V13.4412C19.75 9.85375 18.6562 8.76 15.0687 8.76ZM11 16.8975C9.53875 16.8975 8.3575 15.7075 8.3575 14.255C8.3575 12.7937 9.5475 11.6125 11 11.6125C12.4525 11.6125 13.6425 12.8025 13.6425 14.255C13.6425 15.7162 12.4612 16.8975 11 16.8975Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.f6e7a63835cbb2abfe985c986cda8302.svg";
export { ForwardRef as ReactComponent };